import React from 'react';
import PropTypes, { string } from 'prop-types';

import {
  Text,
  TableParentTooltip,
  WithTooltip
} from 'components/common/Elements/Elements';

import classes from './OneOrGroup.module.scss';

const OneOrGroup = ({ data, text }) => {
  if (data) {
    if (Array.isArray(data)) {
      return (
        <WithTooltip
          text={<TableParentTooltip data={data} title={text} />}
          position={'top'}
        >
          <div>
            <Text size={4} className={classes.blue}>
              {text}
            </Text>
          </div>
        </WithTooltip>
      );
    } else {
      return data;
    }
  }

  return 'NA';
};

OneOrGroup.propTypes = {
  text: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(string)])
};

export default OneOrGroup;
